import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitOrder(payload) {
  const { data } = await api.post("/orders", payload);
  return data;
}

export async function suggestDesign(payload) {
  const { data } = await api.post("/ai/design-suggest", payload);
  return data;
}

export async function fetchGallery() {
  const { data } = await api.get("/gallery");
  return data.items || [];
}

export async function adminLogin(token) {
  const { data } = await api.post("/admin/login", { token });
  return data;
}

export async function fetchOrders(token) {
  const { data } = await api.get("/admin/orders", {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function createGalleryItem(payload, token) {
  const { data } = await api.post("/admin/gallery", payload, {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function deleteGalleryItem(id, token) {
  const { data } = await api.delete(`/admin/gallery/${id}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
}
